<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('stock_conversion')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link to="/stock/conversion" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
            <div class="pull-right">
                <div class="btn-group tool-group" role="group">
                    <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(1)" :class="{active:viewType==1}"><i class="fa fa-th-large" aria-hidden="true"></i></button>
                    <button type="button" class="btn btn-default btn-sm" @click="viewTypeChange(0)" :class="{active:viewType==0}"><i class="fa fa-list-ul" aria-hidden="true"></i></button>
                </div>
            </div>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="query.Text" placeholder="លេខកូដ ឈ្មោះ" @keypress.enter="listPrice"/>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <div>
                                    <button type="button" class="btn btn-default btn-sm" @click="listPrice"><i aria-hidden="true" class="fa fa-search"></i> {{$t('search')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-striped table-sm no-bor">
                                <thead>
                                <tr>
                                    <th class="text-center" style="width: 50px;">{{ $t('no') }}</th>
                                    <th>{{ $t('item_code')}}</th>
                                    <th>{{ $t('item_name')}}</th>
                                    <th>{{ $t('uom') }}</th>
                                    <th class="text-right">{{ $t('cost')}}</th>
                                    <th class="text-right">{{ $t('price') }}</th>
                                    <th class="text-right">{{ $t('unit_qty') }}</th>
                                    <th class="text-right">{{ $t('qty') }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(ret, index) in records" :key="index">
                                    <td class="text-center">{{index+1}}</td>
                                    <td><router-link :to="{ name: 'stock_conversion_update', params:{ id:ret.Id }}">{{ret.ItemCode}}</router-link>
                                    <td>{{ret.ItemName}}</td>
                                    <td>{{ret.UomName}} => {{ret.FromUomName}}</td>
                                    <td class="text-right">{{$money(ret.Cost)}}</td>
                                    <td class="text-right">{{$money(ret.Price)}}</td>
                                    <td class="text-right">{{ret.UnitQty}}</td>
                                    <td class="text-right">{{ret.Quantity}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col-sm-12">
                            <span>{{$t('total_record')}}: {{query.Total}}</span>
                            <div class="pull-right">
                                <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                                hide-goto-end-buttons
                                @change="paging($event)"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                query: {
                    Page: 1,
                    Total: 0,
                    Limit: 20,
                    Text: '',
                    ProductTypeId: ''
                },
                records: [],
                items: [],
                edit: {},
                viewType: 0
            };
        },
        created() {
            this.listPrice();
        },
        methods: {
            listPrice() {
                let loading = this.$loading.show();
                this.$api().post('item/prices', this.query).then(res => {
                    if (this.$isValid(res)) {
                        this.records = res.data.Json.ItemPrices;
                        this.query.Total = res.data.Total;
                    }
                }).finally(function(){ loading.hide(); });
            },
            viewTypeChange(n){
                this.viewType = n;
                this.toList();
            },
            paging(e){
                this.query.Page = e;
                this.listPrice();
            }
        }
    };
</script>